import React from 'react';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';
import { Typography } from '@mui/material';
import { Button } from '@mui/material';

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

import { COMMUNITY_FORUM } from '../../utils/constants/general';
import Link from '../../components/Link/Link';
import { URL } from '../../utils/constants/general';

const ErrorPage = () => {
	const { t } = useTranslation();

	function generateDescription(descriptionStr) {
		const description = descriptionStr.split('^communityForum^');

		return [
			description[0],
			<Link key={description[0]} href={COMMUNITY_FORUM.url}>
				{t('general.communityForum')}
			</Link>,
			description[1]
		];
	}

	return (
		<Grid
			container
			direction="column"
			alignItems="center"
			sx={{ textAlign: 'center', paddingTop: '7rem', minHeight: '80vh' }}>
			<Grid item>
				<ErrorOutlineIcon sx={{ fontSize: '5rem', marginBottom: '2rem' }} />
				<Typography href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap" variant="h1">
					404
				</Typography>
			</Grid>

			<Grid item sx={{ marginBottom: '4rem' }}>
				<Typography variant="h4">{t('pages.error.messages.pageNotFound.title')}</Typography>
			</Grid>

			<Grid item sx={{ marginBottom: '2rem' }}>
				<Typography variant="body1" sx={{ maxWidth: '30rem' }}>
					{generateDescription(t('pages.error.messages.pageNotFound.description'))}
				</Typography>
			</Grid>

			<Button
				color="primary"
				variant="contained"
				onClick={() => {
					window.location.href = URL.PRT_PLUS;
				}}
				sx={{
					color: 'white'
				}}>
				{t('pages.error.messages.pageNotFound.button')}
			</Button>
		</Grid>
	);
};

export default ErrorPage;
